import { FormikProps } from 'formik';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyFieldText } from 'src/components/mui-overrides/Currency';
import { Asset } from 'src/models';
import { number, object } from 'yup';
import { TPayoutInterval } from '@brickwise/asset-validation/dist/schema/enums';

export const validationSchemaRentSurplus = (maxRent: number) =>
  object({
    rentSurplus: number()
      .min(0, 'Rent payout can not be negative.')
      .required('Rent Surplus is required'),
  });

const calculateRentSurplus = (asset: Asset | undefined) => {
  if (asset === undefined) return '0.00';

  const period = asset.rentalDetails?.payoutInterval || TPayoutInterval.quarterly;

  if (period === TPayoutInterval.quarterly) return (Number(asset?.rentalDetails?.rentalSurplus ?? 0) / 4).toFixed(2); // quarterly: 4 times a year
  if (period === TPayoutInterval.monthly) return (Number(asset?.rentalDetails?.rentalSurplus ?? 0) / 12).toFixed(2); // monthly: 12 times a year
  if (period === TPayoutInterval.yearly) return Number(asset?.rentalDetails?.rentalSurplus ?? 0).toFixed(2); // yearly: 1 time a year
};

export const getInitValuesRentSurplus = (asset: Asset | undefined, availableBalance: number) => {
  if (Number(calculateRentSurplus(asset)) > availableBalance) return { rentSurplus: availableBalance.toFixed(2) };
  return {
    rentSurplus: calculateRentSurplus(asset),
  };
};

export interface RentSurplusValues {
  rentSurplus: string;
}

interface Props {
  formik: FormikProps<RentSurplusValues>;
  setRentSurplusString: (rentSurplusString: string) => void;
}

const watchRentSurplusValue = (formik: FormikProps<any>, setRentSurplusString: (rentSurplusString: string) => void) => {
  useEffect(() => {
    if (!formik.values.rentSurplus) setRentSurplusString('0.00');
    if (isNaN(Number(formik.values.rentSurplus))) setRentSurplusString('0.00');
    if (Number(formik.values.rentSurplus) < 0) setRentSurplusString('0.00');
    if (Number(formik.values.rentSurplus) > 0) setRentSurplusString(formik.values.rentSurplus);
  }, [formik.values.rentSurplus]);
};

export const RentSurplus: FC<Props> = ({ formik, setRentSurplusString }) => {
  const { t } = useTranslation();
  watchRentSurplusValue(formik, setRentSurplusString);
  return (
    <form onSubmit={formik.handleSubmit}>
      {/* <DefaultTextField label={t('issuer.rent.form.rentSurplus')} fieldName="rentSurplus" formik={formik} /> */}
      <CurrencyFieldText label={t('issuer.rent.form.rentSurplus')} fieldName="rentSurplus" formik={formik} currency="€" />
    </form>
  );
};
